import { DownloadSimple } from '@phosphor-icons/react';
import { useDownloadFile } from 'src/hooks';
import { SVG_SIZE_M } from 'src/constants';
import { Button } from 'src/v2/commonComponents/Button';

type DownloadButtonProps = {
  url: string;
  className?: string;
};

export const DownloadButton = ({ url }: DownloadButtonProps) => {
  const { onDownloadFile } = useDownloadFile();

  return (
    <Button
      color="secondary"
      shape="round"
      title="Press D"
      onClick={(e) => {
        e.stopPropagation();
        onDownloadFile(url);
      }}
    >
      <DownloadSimple size={SVG_SIZE_M} />
    </Button>
  );
};
